import instance, { ADMIN_PREFIX } from 'services/api';
import { DoctorPlan, DoctorPlanInput } from 'types/api/doctorPlans';

export const createDoctorPlan = (
  doctorId: string | number,
  input: DoctorPlanInput
) =>
  instance.post<DoctorPlan>(`${ADMIN_PREFIX}/doctors/${doctorId}/plans`, input);

export const updateDoctorPlan = (
  doctorId: string | number,
  id: string | number,
  input: DoctorPlanInput
) =>
  instance.put<DoctorPlan>(
    `${ADMIN_PREFIX}/doctors/${doctorId}/plans/${id}`,
    input
  );

export const deleteDoctorPlan = (
  doctorId: string | number,
  id: string | number
) =>
  instance.delete<{ status?: boolean; message?: string }>(
    `${ADMIN_PREFIX}/doctors/${doctorId}/plans/${id}`
  );
